import {
  ProviderEntryDTO,
} from 'dtos';
import {
  notEmptyString,
} from '@populateui/utils';
import isNil from 'lodash/isNil';

export type ProviderEntryConfigTarget =
  | {
      kind: 'existing';
      providerEntryId: number;
    }
  | {
      kind: 'draft';
      providerEntry: ProviderEntryDTO;
    };

export function getProviderEntryConfigTarget(
  providerEntry: ProviderEntryDTO,
): ProviderEntryConfigTarget {
  const { providerEntryId } = providerEntry;

  if (!isNil(providerEntryId) && providerEntryId > 0) {
    return {
      kind: 'existing',
      providerEntryId,
    };
  }

  return {
    kind: 'draft',
    providerEntry,
  };
}

export type ProviderEntryConfigLookup =
  | {
      kind: 'providerEntryId';
      providerEntryId: number;
    }
  | {
      kind: 'npiNumber';
      npiNumber: string;
    }
  | {
      kind: 'unavailable';
    };

export function getProviderEntryConfigLookup(
  target: ProviderEntryConfigTarget | null,
): ProviderEntryConfigLookup {
  switch (target?.kind) {
    case 'existing':
      return {
        kind: 'providerEntryId',
        providerEntryId: target.providerEntryId,
      };
    case 'draft': {
      const npiNumber = target.providerEntry.npi?.number;
      if (typeof npiNumber === 'string' && notEmptyString(npiNumber)) {
        return {
          kind: 'npiNumber',
          npiNumber,
        };
      }

      return {
        kind: 'unavailable',
      };
    }
    default:
      return {
        kind: 'unavailable',
      };
  }
}

export function getProviderEntryConfigQueryKey(target: ProviderEntryConfigTarget | null) {
  const lookup = getProviderEntryConfigLookup(target);

  switch (lookup.kind) {
    case 'providerEntryId':
      return ['provider-entry-config', lookup.kind, lookup.providerEntryId] as const;
    case 'npiNumber':
      return ['provider-entry-config', lookup.kind, lookup.npiNumber] as const;
    case 'unavailable':
    default:
      return ['provider-entry-config', lookup.kind] as const;
  }
}
